import { Toolbar } from "@mui/x-data-grid-pro";
import { ExportMenu } from "./export-menu";

import type { FC } from "react";

export const CsvExportButton: FC = () => (
  <Toolbar>
    <ExportMenu />
  </Toolbar>
);
